import { BaseFormComponent } from 'src/app/shared/components/base-form-component/base-form-component';
import { Component, Injector } from '@angular/core';
import { Validators } from '@angular/forms';
import { REGEX } from 'src/app/app.validators';
import { Product } from '../../products/product.model';
import { ProductsService } from '../../products/products.service';
import { ColorService } from '../../settings/services/color.service';
import { SizeService } from '../../settings/services/size.service';
import { Stock } from '../stock.model';
import { StockService } from '../stock.service';
import { Color } from '../../settings/models/color.model';
import { Size } from '../../settings/models/size.model';

@Component({
    selector: 'ng-stock-form',
    templateUrl: 'stock-form.component.html',
    styleUrls: ['./stock-form.component.css']
})

export class StockFormComponent extends BaseFormComponent<Stock>{

    public colors:Array<Color>;
    public sizes:Array<Size>;
    public products:Array<Product>;

    constructor(
        protected injector: Injector,
        protected stockServ:StockService,
        protected sizeServ:SizeService,
        protected productsServ:ProductsService,
        protected colorsServ:ColorService,
    ) {
        super(injector,'stock','/admin/stock/list',Stock.fromJsonToObject,stockServ);
    }

    protected initChildProprieties(): void {
        this.colors=new Array<Color>();
        this.sizes=new Array<Size>();
        this.products=new Array<Product>();
    }

    protected initChildMethods(): void {
        this.formSubscription.add(this.colorsServ.getAll().subscribe((colors:Color[]) => {this.colors=colors}))
        this.formSubscription.add(this.sizeServ.getAll().subscribe((sizes:Size[]) => {this.sizes=sizes}))
        this.formSubscription.add(this.productsServ.getAll().subscribe((products:Product[]) => {this.products=products}))
    }

    protected buildForm(): void {
        
        this.objectForm=this.formBuilder.group({
            id:this.formBuilder.control(null),
            product_id:this.formBuilder.control(null,[Validators.required]),
            color_id:this.formBuilder.control(null,[Validators.required]),
            size_id:this.formBuilder.control(null,[Validators.required]),
            visible:this.formBuilder.control(null,[Validators.required]),
            flash:this.formBuilder.control(null,[Validators.required]),
            price:this.formBuilder.control(null,[Validators.required,Validators.pattern(REGEX.numberPatternQuantity)]),
            quant_total:this.formBuilder.control(null,[Validators.required,Validators.pattern(REGEX.numberPatternNoComma)]),
            quant_min:this.formBuilder.control(null,[Validators.required,Validators.pattern(REGEX.numberPatternNoComma)]),
          })

        //the input for send image files to api   
         this.imageInputControlName='urls[]';
    }

}